<button
  #assigneeButton
  (click)="
    _.setMenuOpen(!_.locked);
    $event.stopPropagation();
    preventDefault ? $event.preventDefault() : null
  "
  class="rv-center rv-pointer"
>
  <ng-container *ngIf="assignedUserIds != null; else noassignedusers">
    <riv-badge
      [size]="compact ? 'small' : 'medium'"
      [variant]="icon ? 'categorical-9' : 'disabled'"
    >
      <ng-container *ngIf="_.assignedAvatars?.length > 0; else unassigned">
        <ng-container *ngFor="let avatar of _.assignedAvatars">
          <avatar [avatarState]="avatar.avatarState"></avatar>
        </ng-container>
      </ng-container>
      <ng-template #unassigned>Unassigned</ng-template>
      <riv-icon [name]="'ChevronDown'" [size]="compact ? 16 : 24"></riv-icon>
    </riv-badge>
  </ng-container>
  <ng-template #noassignedusers>
    <button
      rivButton
      [size]="'medium'"
      [disabled]="_.locked"
      [icon]="'ChevronDown'"
      [iconPosition]="'last'"
    >
      Assign
    </button>
  </ng-template>
</button>

<ng-container *ngIf="_.menuOpen">
  <deprecated-callout
    *deprecated-callout
    [anchor]="assigneeButton"
    [preferredPosition]="AnchoredPosition.BOTTOM_LEFT"
    (close)="_.setMenuOpen(false)"
  >
    <div class="rv-menu">
      <div class="rv-menu-scrollable">
        <option-select
          *ngIf="allowMultiple"
          [filterable]="true"
          [options]="_.userOptions"
          [selectedOptionIds]="_.selectedUserIds"
          (selectedOptionIdsChange)="_.setSelectedUserIds($event)"
          [multiSelect]="true"
          [minSelectedCount]="allowUnassigned ? 0 : 1"
          [showAvatars]="true"
          [selectedEnabled]="false"
        ></option-select>
        <option-select
          *ngIf="!allowMultiple"
          [filterable]="true"
          [options]="_.userOptions"
          [selectedOptionIds]="_.selectedUserIds"
          [selectedOptionId]="null"
          (selectedOptionIdChange)="_.setSelectedUserIds([$event])"
          [multiSelect]="false"
          [allowMultiSelectedSingleSelect]="true"
          [minSelectedCount]="allowUnassigned ? 0 : 1"
          [showAvatars]="true"
          [selectedEnabled]="false"
        ></option-select>
        <button
          *ngIf="issueType == 'denial' || issueType == 'nonresponse'"
          [rivetLink]="[
            '/',
            'accounts',
            accountId | async,
            'settings',
            issueType == 'denial'
              ? 'denials'
              : issueType == 'nonresponse'
                ? 'non-response'
                : 'underpayments',
            'assignments'
          ]"
          rivButton
          [variant]="'basic'"
          [size]="'medium'"
          [full]="true"
          class="edit-rules-button"
          target="_blank"
          [disabled]="_.settingsLocked"
          [locked]="_.settingsLocked"
        >
          Edit assignment rules
        </button>
      </div>
      <div class="rv-menu-footer flex-fe">
        <a class="rv-link" (click)="cancel()">Cancel</a>
        <a
          class="rv-link"
          (click)="_.setMenuOpen(false); _.sendSelectedUserIds()"
          >Apply</a
        >
      </div>
    </div>
  </deprecated-callout>
</ng-container>
<ng-container *ngIf="loadable.erred">
  <toast *toast [type]="'error'">Failed to update</toast>
</ng-container>
<ng-template #loading>Saving...</ng-template>
